import './header.scss';
import {LANG_LABELS} from '@/ts/enums';
import {SearchableSelect} from '@/ts/utils/custom-select-full';

//Init Header component, submenu and search and functions to enable better accessibility features.

export default function Header() {
    const $header = document.querySelector('header') as HTMLElement;
    const $headerOnTop = document.querySelector('#header-on-top') as HTMLDivElement;

    if ($headerOnTop) {
        const $linksContainer = $headerOnTop.querySelector('.links-item-lang .links');
        const $selectLanguage = $headerOnTop.querySelector('select[id=language-select]');
        const $links = $linksContainer?.querySelectorAll('li');

        if ($selectLanguage) {
            $links?.forEach(($link: any) => {
                const $linkEl = $link.querySelector('.language-link');
                const linkActive = $linkEl.classList.contains('is-active');
                const $optionEl = document.createElement('option');
                $optionEl.setAttribute('data-value', $linkEl.href);
                $optionEl.value = $linkEl.hreflang;
                const languageLabel =
                    LANG_LABELS && LANG_LABELS.find(l => l.value.toLowerCase() === $link.getAttribute('data-text').toLowerCase())
                        ? LANG_LABELS.find(l => l.value.toLowerCase() === $link.getAttribute('data-text').toLowerCase())?.label
                        : '';
                $optionEl.innerText = languageLabel ? languageLabel : $link.getAttribute('data-text');
                $optionEl.setAttribute('data-front', $link.getAttribute('data-text'));
                $optionEl.selected = linkActive;
                if (linkActive) {
                    $optionEl.setAttribute('selected', 'true');
                }

                $selectLanguage.appendChild($optionEl);
            });

            SearchableSelect.init($selectLanguage, 'index-language', {isMulti: false});

            const $customSelect = $headerOnTop.querySelector('.search-select__container');

            if ($customSelect) {
                const $links = $customSelect.querySelectorAll('.option-div');
                const $opener = $customSelect.querySelector('.search-select__opener') as HTMLElement;

                $links.forEach(($link: any) => {
                    const value = $link.getAttribute('data-value');
                    const dataFront = $link.getAttribute('data-front');
                    if (value) {
                        $link.addEventListener('click', () => {
                            window.location.href = value;
                        });

                        $link.addEventListener('keyup', (e : KeyboardEvent) => {
                            if(e.key === 'Enter'){
                                window.location.href = value;
                            }
                        });
                    }

                    if($opener && dataFront){
                        if ($opener.innerHTML.toLowerCase() === dataFront.toLowerCase()) {
                            $opener.setAttribute('aria-label', $link.querySelector('.text').innerHTML.toLowerCase());
                        }
                    }
                });
            }
        }
    }

    if ($header) {
        const $openMenuBtn = $header.querySelector('.mobile-menu-btn');
        const $closeMenuBtn = $header.querySelector('.close');
        const $menuMobile = $header.querySelector('.menu-mobile-sidebar') as HTMLDivElement;
        const $focusRestart = $header.querySelector('.focus-restart') as any;
        const $restartLogo = $header.querySelector('.focus-restart-logo') as any;
        const $submenus = $header.querySelectorAll('.pages-wrapper .submenus');
        const $searchSection = $header.querySelector('.search-section') as HTMLDivElement;
        const $searchContent = $searchSection?.querySelector('.search-content') as HTMLDivElement;
        const $input = $header.querySelector('.input') as HTMLInputElement;
        let $links: any = null;
        let $logoSidebar: any = null;
        let isModalOpen = false;
        let initialWindowHeight = window.innerHeight;
        let currentScroll = window.scrollY;
        const $linksDesktop = $header.querySelector('.content .content.inner .pages') as HTMLElement;
        const $content = $header.querySelector('.content') as HTMLDivElement;

        function getHeaderOnTopHeight() {
            let scrollTop = window.scrollY || document.documentElement.scrollTop;
            let windowHeight = window.innerHeight;
            return Math.min(windowHeight, $headerOnTop?.offsetTop + $headerOnTop?.offsetHeight - scrollTop);
        }

        function isIphone() {
            return /iPhone/.test(navigator.userAgent);
        }

        function handleScroll() {
            const currentScroll = document.documentElement.scrollTop;

            if ($linksDesktop) {
                const linkHeight = $linksDesktop.clientHeight;
                let headerOnTopVisibleHeight = getHeaderOnTopHeight();

                if ($searchSection) {
                    if (currentScroll > $linksDesktop?.offsetTop) {
                        if (window.innerWidth < 1200 && !isIphone()) {
                            $searchContent.style.top = $content?.clientHeight + headerOnTopVisibleHeight + 'px';
                        } else if (window.innerWidth < 1200 && isIphone()) {
                            if ($header.classList.contains('sticky-mobile')) {
                                $searchContent.style.top = $content?.clientHeight + 'px';
                            } else if (!$header.classList.contains('sticky-mobile') && $searchSection.classList.contains('visible')) {
                                $searchContent.style.top = '124px'
                            } else {
                                $searchContent.style.top = $content?.clientHeight + headerOnTopVisibleHeight + 'px'
                            }
                        } else {
                            $searchContent.style.top = linkHeight + 'px';
                        }
                    } else {
                        $searchContent.style.top = $content?.clientHeight + headerOnTopVisibleHeight + 'px';
                    }
                }

                new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                            $header?.classList.remove('sticky-desktop');
                            observer.disconnect();
                        } else {
                            $header?.classList.add('sticky-desktop');
                            observer.disconnect();
                        }
                    });
                }).observe($content);
            }

            if (isModalOpen) return;

            if ($content) {
                const contentHeight = $content.clientHeight;
                if (window.innerWidth < 1200 && currentScroll > $content.offsetTop) {
                    $header.classList.add('sticky-mobile');
                    if ($searchSection) {
                        $searchContent.style.top = contentHeight + 'px';
                    }
                } else {
                    $header.classList.remove('sticky-mobile');
                }
            }
        }

        function handleResize() {
            if ($searchSection) {
                if ($headerOnTop) {
                    $searchContent.style.top = $content.clientHeight + $headerOnTop?.clientHeight + 'px';
                } else {
                    $searchContent.style.top = $content.clientHeight + 'px';
                }
            }

            handleScroll();
        }

        function openMenu() {
            $menuMobile?.setAttribute('tabIndex', '0');
            $focusRestart?.setAttribute('tabIndex', '0');
            $menuMobile?.focus();
            $menuMobile?.classList.add('visible');
            document.body.classList.add('has-mask');
            document.body.style.overflow = 'hidden';
            $closeMenuBtn?.setAttribute('tabIndex', '0');
            $logoSidebar?.setAttribute('tabIndex', '0');
            if ($links) {
                const $labels = $links.querySelectorAll('li label');
                const $inputs = $links.querySelectorAll('li input');

                $links.querySelectorAll('li a').forEach(($link: any) => {
                    $link.setAttribute('tabIndex', '0');
                });

                if ($labels && $labels.length) {
                    $labels.forEach(($link: any) => {
                        $link.setAttribute('tabindex', '0');
                    });
                }

                if ($inputs && $inputs.length) {
                    $inputs.forEach(($link: any) => {
                        $link.setAttribute('tabindex', '0');
                    });
                }
            }

            document.addEventListener('keydown', e => {
                if (e.key === 'Tab') {
                    if ($menuMobile.classList.contains('visible')) {
                        if (e.shiftKey) {
                            if (document.activeElement === $menuMobile) {
                                $links.querySelector('li:last-child a')?.focus();
                            }
                        } else {
                            if (document.activeElement === $restartLogo) {
                                $focusRestart.focus();
                            } else if (document.activeElement === $focusRestart) {
                                $menuMobile.focus();
                            }
                        }
                    }
                }
            });
        }

        function closeMenu() {
            $menuMobile?.setAttribute('tabIndex', '-1');
            $focusRestart?.setAttribute('tabIndex', '-1');
            $menuMobile?.classList.remove('visible');
            document.body.classList.remove('has-mask');
            document.body.style.overflow = 'scroll';
            $closeMenuBtn?.setAttribute('tabIndex', '-1');
            $logoSidebar?.setAttribute('tabIndex', '-1');
            if ($links) {
                const $labels = $links.querySelectorAll('li label');
                const $inputs = $links.querySelectorAll('li input');

                $links.querySelectorAll('li a').forEach(($link: any) => {
                    $link.setAttribute('tabIndex', '-1');
                });

                if ($labels && $labels.length) {
                    $labels.forEach(($link: any) => {
                        $link.setAttribute('tabindex', '-1');
                    });
                }

                if ($inputs && $inputs.length) {
                    $inputs.forEach(($link: any) => {
                        $link.setAttribute('tabindex', '-1');
                    });
                }
            }
        }

        function handleAccessibility($item: Element) {
            const $allCheckboxes = $header.querySelectorAll('.hidden-checkbox');
            const $checkbox = $item.querySelector('.hidden-checkbox') as HTMLInputElement;
            const $labels = $item.querySelectorAll('label');

            if ($labels.length) {
                $labels.forEach(($label: any) => {
                    $label.addEventListener('keyup', (e: KeyboardEvent) => {
                        if (e.key === 'Enter') {
                            if ($allCheckboxes && $allCheckboxes.length) {
                                $allCheckboxes.forEach(($el: any) => {
                                    if ($el.checked && $el !== $checkbox) {
                                        $el.checked = false;
                                    }
                                });
                            }

                            if ($checkbox) {
                                $checkbox.checked = !$checkbox.checked;
                            }
                        }
                    });
                });
            }
        }

        function handleAriaExpanded($el: any) {
            if ($el.checked === true) {
                $el.parentElement.setAttribute('aria-expanded', 'true');
            } else {
                $el.parentElement.setAttribute('aria-expanded', 'false');
            }
        }

        function handleCheckboxChange($checkboxes: any) {
            $checkboxes.forEach(($checkbox: any) => {
                $checkbox.addEventListener('change', function () {
                    $checkboxes.forEach(($el: any) => {
                        if ($el !== $checkbox) {
                            $el.checked = false;
                        }

                        handleAriaExpanded($el);

                        if ($searchSection.classList.contains('visible') && $el.checked === true && window.innerWidth > 992) {
                            $searchSection.classList.remove('visible');
                            document.body.style.overflow = 'scroll';
                            $header.classList.remove('search-open');
                        }
                    });
                });
            });
        }

        function handleSubmenu() {
            const $checkboxMobile = $menuMobile?.querySelectorAll('li.has-submenu');
            const $checkboxDesktop = $header.querySelectorAll('.content li.has-submenu');

            if ($checkboxMobile && $checkboxMobile.length) {
                const $submenuContents = Array.from($menuMobile.querySelectorAll('.submenus .navbar-nav'));
                const $checkboxes = $menuMobile.querySelectorAll('.hidden-checkbox');
                const $labels = $menuMobile.querySelectorAll('label');

                $checkboxMobile.forEach(($item: any, index: number) => {
                    $item.setAttribute('aria-haspopup', 'menu');
                    const $input = $item.querySelector('input') as HTMLInputElement;
                    const $label = $item.querySelector('label') as HTMLElement;

                    $input && $input.setAttribute('id', `checkbox-mobile-${index}`);
                    $label && $label.setAttribute('for', `checkbox-mobile-${index}`);

                    if ($item.classList.contains('is-active')) {
                        $input.checked = true;
                    }

                    $submenuContents.forEach(($content: any, index: number) => {
                        $content.setAttribute('id', `checkbox-mobile-${index}`);
                    });

                    handleAccessibility($item);
                });

                if ($labels.length) {
                    $labels.forEach($label => {
                        $label.addEventListener('keyup', (e: KeyboardEvent) => {
                            if (e.key === 'Enter') {
                                $checkboxes.forEach(($checkbox: any) => {
                                    handleAriaExpanded($checkbox);
                                });
                            }
                        });
                    });
                }

                if ($checkboxes.length) {
                    handleCheckboxChange($checkboxes);
                }
            }

            if ($checkboxDesktop.length) {
                $checkboxDesktop.forEach(($item: any, index: number) => {
                    $item.setAttribute('aria-haspopup', 'menu');
                    const $input = $item.querySelector('input') as HTMLElement;
                    const $label = $item.querySelector('label') as HTMLElement;
                    const $submenuContents = Array.from($item.querySelectorAll('.navbar-nav'));
                    const $checkboxes = $header.querySelectorAll('.content .hidden-checkbox');
                    const $checkbox = $item.querySelector('.hidden-checkbox') as HTMLInputElement;
                    const $link = $item.querySelector('.submenu-title-wrapper .link-arrow') as any;
                    const $close = $item.querySelector('.icn-close') as HTMLElement;

                    document.addEventListener('keydown', e => {
                        if (e.key === 'Tab') {
                            if (e.shiftKey) {
                                if ($link && document.activeElement === $link) {
                                    e.preventDefault();
                                    $close.focus();
                                }
                            } else {
                                if (document.activeElement === $close) {
                                    e.preventDefault();
                                    $link && $link.focus();
                                }
                            }
                        }
                    });

                    handleAccessibility($item);

                    $input && $input.setAttribute('id', `checkbox-${index}`);
                    $label && $label.setAttribute('for', `checkbox-${index}`);
                    $submenuContents.forEach(($el: any, index: number) => $el.setAttribute('id', `checkbox-${index}`));

                    if ($checkboxes.length) {
                        handleCheckboxChange($checkboxes);

                        $checkboxes.forEach(($checkbox: any) => {
                            $checkbox.addEventListener('change', () => {
                                if ($checkbox.checked) {
                                    $header.classList.add('submenu-open');
                                    ($checkbox.parentElement as HTMLElement).setAttribute('aria-expanded', 'true');
                                } else {
                                    $header.classList.remove('submenu-open');
                                    ($checkbox.parentElement as HTMLElement).setAttribute('aria-expanded', 'false');
                                }
                            });

                            $submenus.forEach(($el: any) => {
                                const $icnClose = $el.querySelector('.icn-close') as HTMLElement;
                                $icnClose.addEventListener('click', () => {
                                    if ($checkbox) {
                                        $checkbox.checked = false;
                                    }
                                    $header.classList.remove('submenu-open');
                                    ($checkbox.parentElement as HTMLElement).setAttribute('aria-expanded', 'false');
                                });

                                $icnClose.addEventListener('keydown', e => {
                                    if (e.key === 'Enter') {
                                        if ($checkbox) {
                                            $checkbox.checked = false;
                                        }
                                    }
                                    $header.classList.remove('submenu-open');
                                    ($checkbox.parentElement as HTMLElement).setAttribute('aria-expanded', 'false');
                                });
                            });

                            document.addEventListener('keydown', e => {
                                if (e.key === 'Escape') {
                                    $checkbox.checked = false;
                                }
                                $header.classList.remove('submenu-open');
                                ($checkbox.parentElement as HTMLElement).setAttribute('aria-expanded', 'false');
                            });
                        });
                    }

                    document.addEventListener('click', event => {
                        if (!($item.contains(event.target) || event.target === $checkbox || event.target === $header) && $checkbox) {
                            $checkbox.checked = false;
                            $header.classList.remove('submenu-open');
                            ($checkbox.parentElement as HTMLElement).setAttribute('aria-expanded', 'false');
                        }
                    });
                });
            }
        }

        function openSearch() {
            if ($searchSection) {
                const $searchIcn = $header.querySelector('.search-icn') as HTMLDivElement;
                const $btnClose = $searchSection.querySelector('.close-btn') as HTMLDivElement;
                $searchSection.classList.add('visible');
                document.body.style.overflow = 'hidden';
                $header.classList.add('search-open');
                $searchIcn.setAttribute('aria-expanded', 'true');
                $btnClose.focus();

                const $checkboxes = $header.querySelectorAll('.content .hidden-checkbox');
                if ($checkboxes.length) {
                    handleCheckboxChange($checkboxes);
                }
            }
        }

        function closeSearch() {
            if ($searchSection) {
                const $searchIcn = $header.querySelector('.search-icn') as HTMLDivElement;
                $searchIcn.setAttribute('aria-expanded', 'false');
                $searchSection.classList.remove('visible');
                document.body.style.overflow = 'scroll';
                $header.classList.remove('search-open');
                if (isIphone()) {
                    $content.classList.remove('fixed-safari');
                    $headerOnTop.classList.remove('fixed-safari');
                }
            }
        }

        if ($input) {
            const $placeholder = $header.querySelector('.input-text') as HTMLElement;
            const $btnClose = $searchSection.querySelector('.close-btn') as HTMLDivElement;
            const $deleteBtn = $header.querySelector('.icn-delete') as HTMLElement;
            const $searchBtn = $header.querySelector('.search-btn') as HTMLButtonElement;
            const $redirectLink = $header.querySelector('.redirect-link') as HTMLLinkElement;
            const baseLink = $redirectLink.href;

            if (isIphone()) {
                $input.addEventListener('focus', () => {
                    isModalOpen = true;
                });

                $input.addEventListener('blur', () => {
                    isModalOpen = false;
                    if (!$header.classList.contains('sticky-mobile')) {
                        $content.classList.add('fixed-safari');
                        $headerOnTop.classList.add('fixed-safari');
                    }
                });
            }

            function redirect() {
                const $inputValue = $input.value.trim();
                $input.value = '';

                if ($inputValue !== '') {
                    $redirectLink.href = `${baseLink}${$inputValue}`;
                    window.open(`${baseLink}${$inputValue}`, '_blank');
                } else {
                    $redirectLink.href = `${baseLink}`;
                    window.open(baseLink, '_blank');
                }
            }

            function deleteInput() {
                $deleteBtn.classList.remove('visible');
                $searchBtn.setAttribute('disabled', 'true');
                $input.value = '';
            }

            function reset(event: MouseEvent) {
                const currentEl = event.target as HTMLElement;

                if (currentEl !== $input) {
                    deleteInput();
                }
            }

            function initInput() {
                $input.addEventListener('input', () => {
                    if ($input.value) {
                        $deleteBtn.classList.add('visible');
                        $searchBtn.removeAttribute('disabled');
                    } else {
                        deleteInput();
                    }
                });

                $input.addEventListener('keypress', e => {
                    if (e.key === 'Enter') {
                        ($searchBtn.querySelector('a') as HTMLElement).click();
                    }
                });

                $input.addEventListener('focusin', () => {
                    $placeholder.classList.add('visible');
                });

                $input.addEventListener('focusout', () => {
                    $placeholder.classList.remove('visible');
                });

                $deleteBtn.addEventListener('click', () => {
                    deleteInput();
                });

                $deleteBtn.addEventListener('keypress', e => {
                    if (e.key === 'Enter') {
                        deleteInput();
                        $input.focus();
                    }
                });

                $searchBtn.addEventListener('click', () => {
                    redirect();
                });

                $searchBtn.addEventListener('keypress', e => {
                    if (e.key === 'Enter') {
                        ($searchBtn.querySelector('a') as HTMLElement).click();
                        $btnClose.focus();
                    }
                });

                document.addEventListener('click', event => {
                    reset(event);
                });
            }

            initInput();
        }

        function ui() {
            const $searchIcn = $header.querySelectorAll('.search-icn');
            const $mainNavigation = $header.querySelectorAll('#block-agid-theme-navigazioneprincipale');

            if ($menuMobile) {
                $links = $menuMobile.querySelector('.pages');
                $logoSidebar = $menuMobile.querySelector('a.logo');
                if ($links) {
                    const $labels = $links.querySelectorAll('li label');
                    const $inputs = $links.querySelectorAll('li input');
                    const $icons = $links.querySelectorAll('li i');

                    $links.querySelectorAll('li a').forEach(($link: any) => {
                        $link.setAttribute('tabIndex', '-1');
                    });

                    if ($labels && $labels.length) {
                        $labels.forEach(($link: any) => {
                            $link.setAttribute('tabindex', '-1');
                        });
                    }

                    if ($inputs && $inputs.length) {
                        $inputs.forEach(($link: any) => {
                            $link.setAttribute('tabindex', '-1');
                        });
                    }

                    if ($icons && $icons.length) {
                        $icons.forEach(($link: any) => {
                            $link.setAttribute('tabindex', '-1');
                        });
                    }
                }
            }

            if ($openMenuBtn) {
                $openMenuBtn.addEventListener('click', () => {
                    $openMenuBtn.setAttribute('aria-expanded', 'true');
                    openMenu();
                });
            }

            if ($closeMenuBtn) {
                $closeMenuBtn.addEventListener('click', () => {
                    if ($openMenuBtn) {
                        $openMenuBtn.setAttribute('aria-expanded', 'false');
                    }
                    closeMenu();
                });
            }

            document.addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.key === 'Escape') {
                    if ($openMenuBtn) {
                        $openMenuBtn.setAttribute('aria-expanded', 'false');
                    }
                    closeMenu();
                } else {
                    if (e.key === 'Tab') {
                        if ($menuMobile.classList.contains('visible')) {
                            if (document.activeElement === $focusRestart) {
                                $menuMobile.focus();
                            }
                        }
                    }
                }
            });

            document.addEventListener('click', e => {
                const currentEL = e.target;
                const $clicked = currentEL as any;

                if ($clicked.contains(document.body)) {
                    if ($openMenuBtn) {
                        $openMenuBtn.setAttribute('aria-expanded', 'false');
                    }
                    closeMenu();
                }
            });

            if ($searchIcn.length) {
                $searchIcn.forEach(($icn: any) => {
                    $icn.addEventListener('click', () => {
                        openSearch();
                    });

                    $icn.addEventListener('keypress', (e: KeyboardEvent) => {
                        if (e.key === 'Enter') {
                            openSearch();
                        }
                    });
                });

                if ($searchSection) {
                    if ($headerOnTop) {
                        $searchContent.style.top = $content.clientHeight + $headerOnTop?.clientHeight + 'px';
                    } else {
                        $searchContent.style.top = $content.clientHeight + 'px';
                    }

                    handleScroll();

                    const $closeModalBtn = $searchSection.querySelector('.close-btn') as HTMLDivElement;
                    const $searchBtn = $searchSection.querySelector('.input-container button') as HTMLElement;
                    const $input = $searchSection.querySelector('input') as HTMLInputElement;

                    $input.addEventListener('keyup', e => {
                        if (e.key === 'Tab' && $input.classList.contains('focus-mouse')) {
                            $input.classList.remove('focus-mouse');
                        }
                    });

                    $input.addEventListener('focusout', () => {
                        $input.classList.add('focus-mouse');
                    });

                    document.addEventListener('keydown', function (event) {
                        if (event.key === 'Tab') {
                            if (event.shiftKey) {
                                if (document.activeElement === $closeModalBtn) {
                                    event.preventDefault();
                                    $searchBtn.focus();
                                }
                            } else {
                                if (document.activeElement === $searchBtn && !$searchBtn.getAttribute('disabled')) {
                                    event.preventDefault();
                                    $closeModalBtn.focus();
                                } else if (document.activeElement === $input && $searchBtn.getAttribute('disabled')) {
                                    event.preventDefault();
                                    $closeModalBtn.focus();
                                }
                            }
                        }
                    });

                    const $btnClose = $searchSection.querySelector('.close-btn') as HTMLDivElement;
                    $btnClose.addEventListener('click', () => {
                        closeSearch();
                    });

                    $btnClose.addEventListener('keypress', (e: KeyboardEvent) => {
                        if (e.key === 'Enter') {
                            closeSearch();
                            $searchIcn.forEach(($icn: any) => {
                                $icn.focus();
                            });
                        }
                    });

                    document.addEventListener('keydown', e => {
                        if (e.key === 'Escape' && $searchSection.classList.contains('visible')) {
                            closeSearch();
                            $searchIcn.forEach(($icn: any) => {
                                $icn.focus();
                            });
                        }
                    });
                }
            }

            if($mainNavigation.length) {
                $mainNavigation.forEach(($el) => {
                    $el.removeAttribute('id');
                    $el.setAttribute('data-id', 'block-agid-theme-navigazioneprincipale');
                })
            }
        }

        function init() {
            handleSubmenu();
            ui();

            document.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', handleResize);
        }

        init();
    }
}
